<template>
    <el-checkbox
        v-model="value"
        @change="handleChange">
        <span v-if="value">{{$t("message.cdata.isdefault2")}}</span>
        <span v-else>{{$t("message.cdata.isdefault3")}}</span>
    </el-checkbox>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    data() {
        return {
            value: false,
        }
    },
    props: [ "isDefault", "emailId" ],
    methods: {
        ...mapActions([
            "handleChangeEmail",
        ]),
        handleChange(){
            this.handleChangeEmail({
                id: this.emailId,
                status: 0
            }).then((res) => {
                if(res){
                    this.$message({
                        showClose: true,
                        message: this.$t("message.cdata.succmsg2"),
                        type: "success"
                    })
                }
            })
        }
    },
    created() {
        this.value = !this.isDefault;
    },
}
</script>

<style scoped>

</style>
